import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FrameTooBigExceptionClass;
function FrameTooBigException() {
  if (FrameTooBigExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(frameSize, cause) {
        return new.target.d5g(frameSize, cause);
      }
      static d5g(frameSize, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.de(cause);
        captureStack($this, $this.c5g_1);
        $this.b5g_1 = frameSize;
        delete $this.message;
        return $this;
      }
      r() {
        var sizeSuffix = this.b5g_1 >= 0n ? ': ' + this.b5g_1.toString() : '';
        return 'Frame is too big' + sizeSuffix;
      }
      g14() {
        return FrameTooBigException().d5g(this.b5g_1, this);
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'FrameTooBigException', VOID, VOID, [CopyableThrowable()]);
    FrameTooBigExceptionClass = $;
  }
  return FrameTooBigExceptionClass;
}
//region block: exports
export {
  FrameTooBigException as FrameTooBigException1rgdafsgu31sm,
};
//endregion

//# sourceMappingURL=FrameTooBigException.mjs.map
